module.exports = __webpack_public_path__ + "img/bg_hezuoNo.80e2508f.png";